export const routes = {
  doctors: "/doctors",
  services: "/services",
  schedules: "/schedules",
  bookings: "/appointments",
  events: "/events",
};
